import "./HomePage.css";
import logo from "../assets/logo.png"; // replace with your actual file name

function HomePage() {
  return (
    <div className="coming-soon-container">
      <img src={logo} alt="logo" className="logo" />
      <h1>What's Ria Cookin?</h1>
      <p>Coming soon — cooking up something special!</p>
      <p className="coming-soon-footer">Launching soon</p>
    </div>
  );
}

export default HomePage;
